"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentUrl = exports.wxGetCurrentPages = exports.getEnv = exports.paramSplice = void 0;
var types_1 = require("./types");
// get 参数拼接
var paramSplice = function (params) {
    var result = "";
    // eslint-disable-next-line no-restricted-syntax
    for (var key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
            var value = typeof params[key] === "object"
                ? JSON.stringify(params[key])
                : params[key];
            result += "&".concat(key, "=").concat(value);
        }
    }
    if (result) {
        result = "?".concat(result.slice(1));
    }
    return result;
};
exports.paramSplice = paramSplice;
// 环境变量判断
var getEnv = function (env) {
    return types_1.EnumEnv[env.toUpperCase()] || "";
};
exports.getEnv = getEnv;
// 小程序获取当前界面URL
var wxGetCurrentPages = function () {
    var pages = getCurrentPages(); // 获取加载的页面
    var url = "";
    var options = null;
    var currentPage = pages[pages.length - 1]; // 获取当前页面的对象
    if (currentPage === null || currentPage === void 0 ? void 0 : currentPage.route) {
        url = currentPage.route; // 当前页面url
    }
    options = currentPage === null || currentPage === void 0 ? void 0 : currentPage.options; // 获取url中所带的参数 //拼接url的参数
    if (options) {
        url += "?";
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (var key in options) {
            var value = options[key];
            url += "".concat(key, "=").concat(value, "&");
        }
        url = url.substring(0, url.length - 1);
    }
    return url;
};
exports.wxGetCurrentPages = wxGetCurrentPages;
var getCurrentUrl = function (env) {
    switch (env) {
        case types_1.EnumRuntimeEnv.WX:
            return (0, exports.wxGetCurrentPages)();
        case types_1.EnumRuntimeEnv.WINDOW:
            return window.location.href;
        default:
            return window.location.href;
    }
};
exports.getCurrentUrl = getCurrentUrl;
